import React from "react";

const SEKIcon: React.FC<{ size?: number }> = ({ size = 51 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 8 5"
      width={size}
      height={size}
    >
      <path fill="#005293" d="M0,0H8V5H0Z" />
      <path stroke="#fecb00" d="M0,2.5h8M3,0v5" />
    </svg>
  );
};

export default SEKIcon;
